import { urls } from '../../referenceData';
import fetchWithRetry from '../fetchWithRetry';

export default async () => {
  try {
    const { strings: res } = await fetchWithRetry(
      `${urls.apiUrl()}most/?format=json`, // eslint-disable-line i18next/no-literal-string
    ).then((response) => response.json());

    return res;
  } catch (err) {
    console.error(err);
  }
};
